import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DOCUMENTS_API } from "./apiRoutes";

interface UseGetPostedListProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPostedList = async (data: any, communityId: string) =>
  await axiosAuth.post(`${DOCUMENTS_API(communityId)}/posted/grid`, data);

const useGetPostedList = ({
  data,
  communityId,
  queryParams,
}: UseGetPostedListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["posted-doc-list"],
    queryFn: () => getPostedList(data, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPostedList;
